import { EmailNotifications } from 'api/ordering-service/ordering-service.types';

export const transformExternalOrderingText = (
  externalOrderingEnabled: boolean,
  externalOrderingText: string,
) => {
  return externalOrderingEnabled ? externalOrderingText : null;
};

export const transformEmailNotificationsForRequest = (
  emailNotifications?: EmailNotifications,
) => {
  return emailNotifications.enabled && emailNotifications.list
    ? emailNotifications.list
    : [];
};

export const transformEmailNotificationsForResponse = (
  emailList: string[],
) => ({
  enabled: !!emailList?.length,
  list: emailList,
});
